var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import {} from "../../actions.mjs";
import { elementInstance } from "../instance.mjs";
import { getCountries } from "../../atlas.mjs";
import { billingAddressElementId, paymentIntentClientSecret } from "./elements.mjs";
import { loadStripeIfNeeded, getBillingAddress } from "./utils.mjs";
let billingAddressElement = null;
export const getBillingAddressElement = () => billingAddressElement;
export const initializeStripeBillingAddressElements = (state, actions, cartPayment) => {
    elementInstance({
        elementId: billingAddressElementId,
        idempotencyKey: state.id,
        onMount: (e) => __awaiter(void 0, void 0, void 0, function* () {
            var _a, _b;
            const stripe = yield loadStripeIfNeeded(cartPayment);
            const elementsOptions = (_b = (_a = state.paymentProviderElementsOptions) === null || _a === void 0 ? void 0 : _a.stripe) === null || _b === void 0 ? void 0 : _b.billingAddress.elements;
            const elements = stripe.elements({
                clientSecret: paymentIntentClientSecret(state),
                locale: elementsOptions === null || elementsOptions === void 0 ? void 0 : elementsOptions.locale,
                appearance: elementsOptions === null || elementsOptions === void 0 ? void 0 : elementsOptions.appearance,
                fonts: elementsOptions === null || elementsOptions === void 0 ? void 0 : elementsOptions.fonts,
                loader: elementsOptions === null || elementsOptions === void 0 ? void 0 : elementsOptions.loader,
            });
            const billingElement = yield createBillingAddressElement(elements, state);
            billingAddressElement = billingElement;
            let timer;
            billingElement.on('change', (e) => {
                clearTimeout(timer);
                timer = setTimeout(() => __awaiter(void 0, void 0, void 0, function* () {
                    const address = getBillingAddress(e);
                    yield actions.setBillingAddress(address);
                }), 1000);
            });
            billingElement.mount(e);
            return () => {
                clearTimeout(timer);
                billingElement.unmount();
                billingAddressElement = null;
            };
        }),
    });
};
const createBillingAddressElement = (elements, state) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    const { allCountries } = yield getCountries(state)();
    return elements.create('address', {
        mode: 'billing',
        allowedCountries: allCountries.map(({ code }) => code),
        display: {
            name: 'split',
        },
        defaultValues: state.customer.billingAddress && {
            firstName: state.customer.billingAddress.firstName,
            lastName: state.customer.billingAddress.lastName,
            address: {
                country: (_b = (_a = state.customer.billingAddress.countryCode) === null || _a === void 0 ? void 0 : _a.toUpperCase()) !== null && _b !== void 0 ? _b : '',
                line1: state.customer.billingAddress.address1,
                line2: state.customer.billingAddress.address2,
                city: state.customer.billingAddress.city,
                state: state.customer.billingAddress.stateOrProvince,
                postal_code: state.customer.billingAddress.postalCode,
            },
        },
    });
});
//# sourceMappingURL=billingAddressElements.js.map